export { d as debounce } from './debounce-B-cWYxqK.js';

function fakeAudioStream() {
    const audioCtx = new AudioContext();
    const oscillator = audioCtx.createOscillator();
    const destination = audioCtx.createMediaStreamDestination();
    oscillator.connect(destination);
    oscillator.frequency.value = 400;
    oscillator.type = "sine";
    setInterval(() => {
        if (oscillator.frequency.value <= 900) {
            oscillator.frequency.value += 10;
        }
        else {
            oscillator.frequency.value = 200;
        }
    }, 20);
    oscillator.start();
    return destination.stream;
}

let rotationAngle = 0;
function drawWebcamFrame(canvas) {
    const context = canvas.getContext("2d");
    if (!context) {
        console.error("Canvas context not available");
        return;
    }
    const wheelRadius = 100;
    const wheelCenterX = canvas.width / 2;
    const wheelCenterY = canvas.height / 2;
    context.fillStyle = "darkgreen";
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.save();
    context.translate(wheelCenterX, wheelCenterY);
    context.rotate(rotationAngle);
    const numSlices = 12;
    const sliceAngle = (2 * Math.PI) / numSlices;
    const colors = ["red", "orange", "yellow", "green", "blue", "purple"];
    for (let i = 0; i < numSlices; i++) {
        context.beginPath();
        context.moveTo(0, 0);
        context.arc(0, 0, wheelRadius, i * sliceAngle, (i + 1) * sliceAngle);
        context.fillStyle = colors[i % colors.length];
        context.fill();
        context.closePath();
    }
    context.restore();
    context.fillStyle = "white";
    context.font = "42px Arial";
    const topText = "Whereby Media Stream";
    const topTextWidth = context.measureText(topText).width;
    context.fillText(topText, canvas.width / 2 - topTextWidth / 2, 50);
    context.font = "32px Arial";
    const now = new Date();
    const timeText = `time: ${now.getHours().toString().padStart(2, "0")}:${now
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${now.getSeconds().toString().padStart(2, "0")}.${now
        .getMilliseconds()
        .toString()
        .padStart(3, "0")}`;
    context.fillText(timeText, 10, canvas.height - 20);
    context.fillText(`rotation angle: ${rotationAngle.toFixed(2)}`, canvas.width - canvas.width / 2, canvas.height - 20);
    rotationAngle += 0.01;
}
function fakeWebcamFrame(canvas) {
    drawWebcamFrame(canvas);
    requestAnimationFrame(() => fakeWebcamFrame(canvas));
}

function parseRoomUrlAndSubdomain(roomAttribute, subdomainAttribute) {
    if (!roomAttribute) {
        throw new Error("Missing room attribute");
    }
    const m = /https:\/\/([^.]+)(\.whereby\.com|-ip-\d+-\d+-\d+-\d+.hereby.dev:4443)\/.+/.exec(roomAttribute);
    const subdomain = (m && m[1]) || subdomainAttribute;
    if (!subdomain) {
        throw new Error("Missing subdomain attribute");
    }
    if (!m) {
        throw new Error("Could not parse room URL");
    }
    const roomUrl = new URL(roomAttribute);
    return {
        subdomain,
        roomUrl,
    };
}

export { fakeAudioStream, fakeWebcamFrame, parseRoomUrlAndSubdomain };
